import { USER_SEARCH_TYPE } from "../../../../constants/picker-entries-constants";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import ET3Radio from "../../../../core/et3-input/et3-radio";
import getUserAdvancedStore from "../../../../stores/user-store/advanced-store";
import { TSearchType } from "../../../../Types";

const OptionCriteriaRadioButton = withLiteObserverAndTheme(() => {
  const userAdvancedStore = getUserAdvancedStore();

  return (
    <ET3Radio
      options={USER_SEARCH_TYPE}
      value={userAdvancedStore.searchType.get()}
      onChoose={(value: TSearchType) => {
        userAdvancedStore.setSearchType(value);
      }}
      style={{
        width: "auto",
        minHeight: 0
      }}
    />
  );
});

export default OptionCriteriaRadioButton;
